import { useEffect, useState } from "react";
import usePageContent from '../utils/usePageContent'; // Adjust path if needed

const images = [
  "/images/about-us/gallery6.png" 
];

const ourMissionImage = [
  "/images/about-us/gallery7.png"
];

const ourStoryImage = [
  "/images/about-us/gallery5.png"
];


const AboutUs = () => {
  const {
    heroTitle,
    heroDescription,
    missionTitle,
    missionDescription,
    storyTitle,
    storyParagraphs = []
  } = usePageContent('about');

  return (
    <div className="main-about">
      {/* Hero Image Section */}
      <div
        className="relative w-full h-[550px] bg-cover bg-center bg-gray-200 rounded-b-lg overflow-hidden"
        style={{ backgroundImage: `url(${images[0]})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="text-center text-white px-4 md:px-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 inline-block relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
              {heroTitle}
            </h2>
            <p className="text-xl md:text-2xl max-w-2xl mx-auto">
              {heroDescription}
            </p>
          </div>
        </div>
      </div>

      {/* Our Mission Section */}
      <div className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-10">
            <div className="md:w-[48%]">
              <img
                src={ourMissionImage[0]}
                alt="Our Mission"
                className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div className="md:w-[52%]">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-red-600">
                {missionTitle}
              </h2>
              <p className="text-lg md:text-xl text-gray-700">
                {missionDescription}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Our Story Section */}
      <div className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row-reverse items-center gap-10">
            <div className="md:w-[48%]">
              <img
                src={ourStoryImage[0]}
                alt="Our Story"
                className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div className="md:w-[52%]">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-red-600">
                {storyTitle}
              </h2>
              <div className="grid gap-6">
                {storyParagraphs.map((para, idx) => (
                  <p key={idx} className="text-lg md:text-xl text-gray-700">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
